import styled from 'styled-components'
import { Box } from 'rebass'
import { rem } from 'polished'

const PseudoInput = styled(Box)`
  font-size: ${(props) => rem(props.theme.fontSizes[2])};
  font-weight: ${(props) => props.theme.weights[1]};
  color: ${(props) => props.theme.colors.blue};
  border: 2px ${(props) => props.theme.colors.grey_light_op30} solid;
  padding: 5px 10px;
  border-radius: 5px;
`
PseudoInput.displayName = 'PseudoInput'

export default PseudoInput
